import React, { Component } from 'react';
import queryString from 'query-string';
import {
  Button,
  Table,
  Input,
  message,
  Modal,
  Popconfirm,
  TreeSelect,
} from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import columns from './columns';
import { backendErrorTip } from '../../../utils';
import xfetch from '../../../xfetch';
import UpdateForm from './UpdateForm';
import s from './style.css';

const { Search } = Input;
const { TreeNode } = TreeSelect;

@withStyles(s)
export default class Spider extends Component {
  constructor(props) {
    super(props);
    this.q = {
      page_size: 10,
      page: 1,
    };
    this.baseApi = `${window.G.backendApi}/knowledge/spider_task/`;
    this.orgTreeApi = `${window.G.backendApi}/profiles/organization/tree/`;
  }
  state = {
    data: {},
    item: {},
    loading: true,
    modals: {
      updateForm: { title: '', visible: false },
    },
    selectedRowKeys: [],
    settings: {},
    treeNodes: [],
  };
  componentDidMount() {
    this.query();
    this.getSettings();
    this.intervalQuery();
    this.queryOrgTree();
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  onTableChange = pagination => {
    const { current } = pagination;
    this.q.page = current;
    this.query();
  };
  onSelectChange = selectedRowKeys => this.setState({ selectedRowKeys });
  setModals({ key, title, item = {}, visible }) {
    this.setState({
      modals: {
        ...this.state.modals,
        [key]: {
          ...this.state.modals[key],
          title,
          visible,
        },
      },
      item,
    });
  }
  intervalQuery = () => {
    this.timer = setInterval(this.query, 5000);
  };
  query = () => {
    const api = `${this.baseApi}?${queryString.stringify(this.q)}`;
    return xfetch(api).then(({ error, result }) => {
      this.setState({
        loading: false,
      });
      if (error) {
        backendErrorTip(error);
        return;
      }
      this.setState({
        data: result,
      });
    });
  };
  queryOrgTree = async () => {
    const { error, result } = await xfetch(this.orgTreeApi);
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      treeNodes: result.tree,
    });
  };
  handleSearch = search => {
    this.q.search = search;
    this.q.page = 1;
    this.query();
  };
  updateItem = () => {
    let title;
    const { item } = this.state;
    const { id } = item;

    this.updateForm.validateFields((err, values) => {
      if (err) {
        return;
      }
      const body = {
        ...values,
      };

      if (id) {
        title = '配置采集任务';
        xfetch(`${this.baseApi}${id}/`, {
          body,
          method: 'PUT',
        }).then(({ error }) => {
          if (error) {
            backendErrorTip(error);
            return;
          }
          this.setModals({ key: 'updateForm', title, visible: false });
          message.success('编辑成功');
          this.query();
        });
      } else {
        title = '添加采集任务';
        xfetch(this.baseApi, {
          body,
          method: 'POST',
        }).then(({ error }) => {
          if (error) {
            backendErrorTip(error);
            return;
          }
          this.setModals({ key: 'updateForm', title, visible: false });
          message.success('添加成功');
          this.query();
        });
      }
    });
  };
  batchDelete = async () => {
    const { selectedRowKeys: ids } = this.state;
    const { error } = await xfetch(
      `${this.baseApi}batch_delete/?real_delete=1&ids=${JSON.stringify(ids)}`,
      {
        method: 'DELETE',
      },
    );
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.q.page = 1;
    this.search = '';
    this.query();
  };
  handleRun = async () => {
    const { selectedRowKeys } = this.state;
    const ids =
      selectedRowKeys instanceof Array ? selectedRowKeys : [selectedRowKeys];
    const { error, result } = await xfetch(
      `${this.baseApi}run/?ids=${JSON.stringify(ids)}`,
    );
    if (error) {
      backendErrorTip(error);
      return;
    }
    message.success('任务已提交执行');
    console.info(error, result);
  };
  getSettings = async () => {
    const { error, result } = await xfetch(
      `${window.G.backendApi}/system/settings/`,
    );
    if (error) {
      return;
    }
    const settings = result.length ? result[0] : {};
    document.title = settings.title;
    this.setState({
      settings,
    });
  };
  renderTreeNodes = tree => {
    const data = Object.values(tree);
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode
            disabled={item.deprecated}
            key={item.id}
            value={item.id}
            title={item.name}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          value={item.id}
          disabled={item.deprecated}
          title={item.name}
        />
      );
    });
  };
  render() {
    const {
      data: { results, count = 0 },
      loading,
      item,
      modals: { updateForm },
      selectedRowKeys,
      settings,
      treeNodes,
    } = this.state;
    const enableSider =
      settings.enabled_model && settings.enabled_model.indexOf('spider') !== -1;
    if (!enableSider) {
      return null;
    }
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const pagination = {
      pageSize: 10,
      total: count,
      showTotal: t => `共 ${t} 条`,
      current: this.q.page,
    };

    const orgTreeNodes = this.renderTreeNodes(treeNodes);
    return (
      <div className={s.wrap}>
        <div className={s.toolbar}>
          <div className={s.toolbarLeft}>
            <span className={s.toolbarField}>
              <span className={s.toolbarLabel}>组织机构：</span>
              <TreeSelect
                showSearch
                style={{ width: 140 }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="请选择"
                allowClear
                onChange={organization => {
                  this.q.organization = organization;
                  this.q.page = 1;
                  this.query();
                }}
                treeDefaultExpandAll
              >
                {orgTreeNodes}
              </TreeSelect>
            </span>
            <Search
              placeholder="输入任务名称搜索"
              onSearch={this.handleSearch}
              enterButton="搜索"
              style={{ width: 260 }}
            />
          </div>
          <div className={s.toolbarRight}>
            <Button
              type="primary"
              onClick={() =>
                this.setModals({
                  key: 'updateForm',
                  title: '添加采集任务',
                  visible: true,
                })
              }
            >
              添加任务
            </Button>
            <Button
              disabled={!selectedRowKeys.length}
              type="default"
              onClick={this.handleRun}
            >
              执行任务
            </Button>
            {selectedRowKeys.length ? (
              <Popconfirm
                title="确认批量删除？"
                placement="left"
                okText="确认"
                cancelText="取消"
                onConfirm={this.batchDelete}
              >
                <Button type="danger">删除</Button>
              </Popconfirm>
            ) : (
              <Button type="danger" disabled>
                删除
              </Button>
            )}
          </div>
        </div>
        <div className={s.table}>
          <Table
            rowKey="id"
            loading={loading}
            dataSource={results}
            columns={columns(this, s)}
            rowSelection={rowSelection}
            pagination={pagination}
            onChange={this.onTableChange}
          />
        </div>
        <Modal
          title={updateForm.title}
          visible={updateForm.visible}
          width={625}
          destroyOnClose
          maskClosable={false}
          onOk={this.updateItem}
          onCancel={() =>
            this.setModals({
              key: 'updateForm',
              title: '',
              visible: false,
            })
          }
          className={s.updateGroupForm}
        >
          <UpdateForm
            orgTreeNodes={orgTreeNodes}
            ref={x => {
              this.updateForm = x;
            }}
            item={item}
          />
        </Modal>
      </div>
    );
  }
}
